import React, { useState } from "react";
import { KTSVG } from "../../../helpers";

type Props = {
  className: string;
  innerPadding?: string;
};

const StepContent20: React.FC<Props> = ({ className, innerPadding = "" }) => {
  const [category, setCategory] = useState("1");
  const [option, setOption] = useState("1");
  const [fleet, setFleet] = useState("1");
  return (

      <div className={`card ${className}`}>
        {/* begin::Body */}
        <div className={`card-body ${innerPadding}`}>
          {/* begin::Title */}
          <div className="mb-10">
            <h3 className="fw-bold text-dark mb-2 fs-3">Identify key assumptions</h3>
            <span className="fs-7 text-muted">
             Read each section and then fill in your answers at the bottom.
            </span>
          </div>
          {/* end::Title */}

          {/* begin::Section */}
          <div className="mb-10">
            <div className="accordion" id="kt_accordion_1">
              <div className="accordion-item">
                <h2 className="accordion-header" id="kt_accordion_1_header_1">
                  <button
                    className="accordion-button fs-7 fw-bold"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#kt_accordion_1_body_1"
                    aria-expanded="true"
                    aria-controls="kt_accordion_1_body_1"
                  >
                    Identify key assumptions
                  </button>
                </h2>
                <div
                  id="kt_accordion_1_body_1"
                  className="accordion-collapse collapse show"
                  aria-labelledby="kt_accordion_1_header_1"
                  data-bs-parent="#kt_accordion_1"
                >
                  <div className="accordion-body">
                    In this step you will determine which assumptions about your business have not been thoroughly tested, and you will rank the top assumptions in order of importance.

                    Identifying key assumptions is the first part of the process to validate your primary market research by looking for customers to take specific actions, which will happen in the next step. Before the assumptions can be tested, they need to be broken down into their component parts, so that each assumption represents a specific, narrow idea that can be empirically tested in the next step using a single experiment design. Do not worry about how you will design the experiment yet. Focus on breaking out all the key assumptions, because if you skip over an assumption fearing that testing it is difficult, you will neglect a potentially important factor in your business’s health.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="kt_accordion_1_header_2">
                  <button
                    className="accordion-button fs-7 fw-bold collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#kt_accordion_1_body_2"
                    aria-expanded="false"
                    aria-controls="kt_accordion_1_body_2"
                  >
                    Identify and prioritize assumptions
                  </button>
                </h2>
                <div
                  id="kt_accordion_1_body_2"
                  className="accordion-collapse collapse show"
                  aria-labelledby="kt_accordion_1_header_2"
                  data-bs-parent="#kt_accordion_1"
                >
                  <div className="accordion-body">
                  Until you have tested your business assumptions and you have shown you will take a specified action, there is too much of a leap of faith for our disciplined entrepreneurial approach. Actions speak louder than words. Those of you familiar with lean startup methodology will see similarities to the concept of a “minimum viable product” or MVP. Over the next two steps, you will unpack your assumptions, breaking them down into a prioritized list to test empirically before you launch your “minimum viable business product” (MVBP).

Review each step of the framework and make a list of the areas in which you have made logical conclusions based on your primary market research.
Have you correctly identified your Persona's priorities?
Will your customer find the value proposition attractive when it comes time for them to make a purchase?
Will the customer make the time and effort to integrate your product into their workflow?
Question assumptions related to your gross margin.
Are your cost targets accurate? If your product is hardware, review the bill of material and carefully analyze the cost of the most important items in the bill of material. If yours is a software development effort, you will do a similar thing, listing the key development challenges, assumptions, and cost items.
Review the Next 10 Customers list.
Review the Decision-Making Unit.
Out of the customers you have already identified, are any of them "lighthouse" customers, where other customers will buy if they do?
Are any "linchpin" customers, where if they don’t buy, others will not? Are there other linchpin customers who you have not yet identified?
Most importantly, are the lighthouse and linchpin customers interested in purchasing your product?
                  </div>
                </div>
              </div>

            </div>
          </div>
          {/* end::Section */}

        </div>
        {/* end: Card Body */}
      </div>

  );
};

export { StepContent20 };
